<template>
  <div class="content benchmark">
    <PulseLoader :loading="!loaded" :class="{hide: loaded}" quote="Action is the foundational key to all success" author="Pablo Picasso" profession="Spanish Painter" img="picasso.jpg"></PulseLoader>
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
      >
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'Search' }">
                Search
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Products
            </li>
          </ol>
        </nav>
        <!-- <div class="md-layout page-wrapper">
          <div class="md-layout-item privacy-policy md-size-100">
              <h1 class="md-title">New Report</h1>
          </div>
        </div> -->
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <div class="md-layout">
          <div class="md-layout-item">
            <md-card class="welcome-card-wrap">
              <md-card-header class="md-card-header-icon new-report-body m-0">
                <!-- <router-link :to="{ name: 'CreateNewReport' }">
                  <div class="new-report">
                    <div class="card-icon">
                      <md-icon>create_new_folder</md-icon>
                    </div>
                    <h4 class="title">Benchmarking Tool</h4>
                    <h3 class="section_header p-0 m-0">Benchmarking Tool</h3>
                  </div>
                </router-link> -->
                <div class="flex_content">
                  <h3 class="section_header p-0 m-0">Benchmarking Tool</h3>
                  <ProgressBar :scale="progress"/>
                </div>
                <!--
                <h4 class="title text-center">
                  <div>
                    Define your inputs<br />
                    <small
                      >Bizminer Reports require inputs. You can choose between
                      our <br />
                      simple (17 inputs per year) or advanced (31 inputs per
                      year) format.</small
                    >
                  </div>
                </h4>-->
              </md-card-header>
              <md-card-content class="welcome-card-container">
                <div class="card_header">Define your inputs</div>
                <p>
                  Bizminer Reports require inputs. You can choose between our
                  simple (17 inputs per year) or advanced (31 inputs per year)
                  format.
                </p>
                <div id="typography">
                  <div class="row">
                    <div class="md-layout px-4">
                      <div
                        class="md-layout-item md-medium-size-50 md-size-50 welcome_cardWpr"
                        @click="showNewInputsModal('simple')"
                      >
                        <stats-card header-color="blue" class="welcome-card">
                          <template slot="header">
                            <div class="card-icon">
                              <i
                                class="icon-primary md-icon md-icon-font md-theme-default"
                                >dns</i
                              >
                            </div>
                            <h4 class="title">
                              <div class="card-title">
                                Simple
                              </div>
                              <div class="card-help-icon">
                                <md-icon>info</md-icon>
                                <div class="card_info">
                                  <div class="info_header">
                                    Simple
                                  </div>
                                  <div class="info_body">
                                    <p>
                                      Pellentesque habitant morbi tristique
                                      senectus et netus et malesuada fames ac
                                      turpis egestas. Donec vestibulum sit amet
                                      felis sit amet accumsan. Sed odio lacus,
                                      varius vel augue vitae, pretium porta est.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </h4>
                          </template>
                          <template slot="footer">
                            <div class="stats">
                              17 inputs per year.RS line items.
                            </div>
                            <a class="more_btn"
                              ><i class="md-icon">double_arrow</i></a
                            >
                          </template>
                        </stats-card>
                      </div>
                      <div
                        class="md-layout-item md-medium-size-50 md-size-50 welcome_cardWpr"
                        @click="showNewInputsModal('advanced')"
                      >
                        <stats-card header-color="blue" class="welcome-card">
                          <template slot="header">
                            <div class="card-icon">
                              <i
                                class="icon-primary md-icon md-icon-font md-theme-default"
                                >storage</i
                              >
                            </div>
                            <h4 class="title">
                              <div class="card-title">
                                Advanced
                              </div>
                              <div class="card-help-icon">
                                <md-icon>info</md-icon>
                                <div class="card_info">
                                  <div class="info_header">
                                    Advanced
                                  </div>
                                  <div class="info_body">
                                    <p>
                                      Pellentesque habitant morbi tristique
                                      senectus et netus et malesuada fames ac
                                      turpis egestas. Donec vestibulum sit amet
                                      felis sit amet accumsan. Sed odio lacus,
                                      varius vel augue vitae, pretium porta est.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </h4>
                          </template>
                          <template slot="footer">
                            <div class="stats">
                              31 inputs per year.More detail option.
                            </div>
                            <a class="more_btn"
                              ><i class="md-icon">double_arrow</i></a
                            >
                          </template>
                        </stats-card>
                      </div>
                    </div>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </div>
          <div class="md-layout-item md-size-100" v-if="loaded">
            <table-card>
              <template slot="header">
                <div class="md-card-content">
                  <!--<h4 class="title">My Data</h4>-->
                  <div class="card_header">My Data</div>
                </div>
              </template>

              <template slot="content">
                <!-- <div>
                  <pulse-loader
                    :color="'blue'"
                    :loading="!loaded"
                  ></pulse-loader>
                </div> -->
                <div class="md-layout">
                  <div class="md-layout-item md-size-100 p-0">
                    <md-table v-model="tableData" table-header-color="blue">
                      <md-table-row slot="md-table-row" slot-scope="{ item }">
                        <md-table-cell md-label="Date Created">{{
                          item.dateCreated
                        }}</md-table-cell>
                        <!-- <md-table-cell md-label="Client">{{
                          item.client
                        }}</md-table-cell> -->
                        <md-table-cell md-label="Data Source">{{
                          item.dataSource
                        }}</md-table-cell>
                        <md-table-cell md-label="Description">{{
                          item.description
                        }}</md-table-cell>
                        <md-table-cell md-label="Inputs Type">{{
                          item.inputsType
                        }}</md-table-cell>
                        <md-table-cell md-label="Search" class="td-actions">
                          <button
                            type="button"
                            class="md-button table-action-button md-theme-default"
                            @click="openReportType(item.id)"
                          >
                            <div class="md-ripple">
                              <div class="md-button-content">
                                <md-icon>manage_search</md-icon>
                              </div>
                            </div>
                          </button>
                        </md-table-cell>
                      </md-table-row>
                    </md-table>
                  </div>
                </div>
              </template>
            </table-card>
          </div>
        </div>
      </div>
    </div>
    <modal v-if="newInputsModal" @close="newInputsModal = false">
      <template slot="header">
        <div v-if="newInputStep === 1">
          <h4 class="modal-title">Input Details</h4>
        </div>
        <div v-if="newInputStep === 2">
          <h4 class="modal-title">Input Type</h4>
        </div>
        <div v-if="newInputStep === 3">
          <h4 class="modal-title">Year Details</h4>
        </div>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="closeNewInputsModal()"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div id="typography">
          <div v-if="newInputStep === 1">
            <div class="row">
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
                  slot="content-right"
                >
                  <div class="client-name-box">
                    <div>
                      <md-field>
                        <label>Description*</label>
                        <md-input type="textarea" v-model="inputDescription" />
                        <validation-error
                          :errors="apiValidationErrors.description"
                        />
                      </md-field>
                    </div>
                  </div>
                  <div class="client-name-box">
                    <div>
                      <md-field>
                        <label>Data Source*</label>
                        <md-input type="textarea" v-model="inputDataSource" />
                        <validation-error
                          :errors="apiValidationErrors.description"
                        />
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="newInputStep === 2">
            <div class="md-layout">
              <!-- <div
                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
              > -->
              <input
                aria-label="Input CSV"
                type="file"
                ref="csvInput"
                accept=".csv"
                @change="fileSelected"
                style="display: none"
              />
              <md-button
                class="md-info md-round mb-4 md-theme-default"
                type="button"
                @click="chooseInputFormat('csv')"
              >
                <i class="md-icon md-icon-font md-theme-default">check</i>
                CSV
              </md-button>
              <!-- </div>
              <div
                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
              > -->
              <md-button
                class="md-info md-round mb-4 md-theme-default"
                type="button"
                @click="chooseInputFormat('inputs')"
              >
                <i class="md-icon md-icon-font md-theme-default">check</i>
                Form Inputs
              </md-button>
              <!-- </div> -->
            </div>
          </div>
          <div class="row" v-if="newInputStep === 3">
            <div class="md-layout">
              <div
                class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
                id="modal-content"
                slot="content-right"
              >
                <div class="client-name-box">
                  <md-field>
                    <label>Year*</label>
                    <md-input type="text" v-model="createData.year"></md-input>
                  </md-field>
                  <md-field style="display: none;">
                    <md-input v-model="myData.type" type="hidden"></md-input>
                  </md-field>
                </div>
                <div class="input-section-label">
                  Income Statement
                </div>
                <div class="client-name-box">
                  <div class="field-wrap">
                    <md-field>
                      <label>Business Revenue*</label>
                      <md-input
                        v-model="createData.businessRevenue"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Cost of Sales - Labor Portion</label>
                      <md-input
                        v-model="createData.costOfSalesLaborPortion"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Gross Margin</label>
                      <md-input
                        v-model="createData.grossMargin"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Officers Compensation</label>
                      <md-input
                        v-model="createData.officersComp"
                        type="text"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'simple'">
                      <label>Pre-tax Net Profit</label>
                      <md-input
                        v-model="createData.preTaxNetProfit"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'simple'">
                      <label>Depreciation-Other Non-Cash Expenses</label>
                      <md-input
                        v-model="createData.depreciationOtherNonCashExpenses"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'simple'">
                      <label>Operating Expenses</label>
                      <md-input
                        v-model="createData.operatingExpenses"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'simple'">
                      <label>Interest Expense</label>
                      <md-input
                        v-model="createData.interestExpense"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Salary-Wages</label>
                      <md-input
                        v-model="createData.salaryWages"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Rent</label>
                      <md-input
                        v-model="createData.rent"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Taxes Paid</label>
                      <md-input
                        v-model="createData.taxesPaid"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Advertising</label>
                      <md-input
                        v-model="createData.advertising"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Benefits-Pensions</label>
                      <md-input
                        v-model="createData.benefitsPension"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Repairs</label>
                      <md-input
                        v-model="createData.repairs"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Bad Debt</label>
                      <md-input
                        v-model="createData.badDebt"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Sales, General, Admin & Misc.</label>
                      <md-input
                        v-model="createData.salesGeneralAdminMisc"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Amortization Depreciation Depletion</label>
                      <md-input
                        v-model="createData.amortizationDepreciationDepletion"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Interest Income</label>
                      <md-input
                        v-model="createData.interestIncome"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Interest Expense</label>
                      <md-input
                        v-model="createData.interestExpense"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Other Income</label>
                      <md-input
                        v-model="createData.otherIncome"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field v-if="myData.type === 'advanced'">
                      <label>Income Tax</label>
                      <md-input
                        v-model="createData.incomeTax"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
                <div class="input-section-label">
                  Balance Sheet
                </div>
                <div class="client-name-box">
                  <div class="field-wrap" v-if="myData.type === 'simple'">
                    <md-field>
                      <label>Accounts Receivable</label>
                      <md-input
                        v-model="createData.accountsReceivable"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Total Current Assets</label>
                      <md-input
                        v-model="createData.totalCurrentAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Total Assets</label>
                      <md-input
                        v-model="createData.totalAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Accounts Payable</label>
                      <md-input
                        v-model="createData.accountsPayable"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Total Current Liabilities</label>
                      <md-input
                        v-model="createData.otherCurrentLiabilities"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Long Term Liabilities</label>
                      <md-input
                        v-model="createData.totalLongTermLiabilities"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
                <div class="client-name-box">
                  <div class="field-wrap" v-if="myData.type === 'advanced'">
                    <md-field>
                      <label>Cash</label>
                      <md-input
                        v-model="createData.cash"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Receivables</label>
                      <md-input
                        v-model="createData.receivables"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Inventory</label>
                      <md-input
                        v-model="createData.inventory"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Other Current Assets</label>
                      <md-input
                        v-model="createData.otherCurrentAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Gross Fixed Assets</label>
                      <md-input
                        v-model="createData.grossFixedAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Accum. Depreciation-Amortization-Depltn.</label>
                      <md-input
                        v-model="createData.accumDepreciationAmortizationDepltn"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Net Fixed Assets</label>
                      <md-input
                        v-model="createData.netFixedAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                    <md-field>
                      <label>Other Non-Current Assets</label>
                      <md-input
                        v-model="createData.otherNonCurrentAssets"
                        type="number"
                      ></md-input>
                    </md-field>
                  </div>
                </div>
                <div v-if="myData.type === 'simple'">
                  <div class="input-section-label">
                    Employment Data
                  </div>
                  <div class="client-name-box">
                    <div class="field-wrap">
                      <md-field>
                        <label>Employment</label>
                        <md-input
                          v-model="createData.employment"
                          type="number"
                        ></md-input>
                      </md-field>
                      <md-field>
                        <label>Average Annual Wage</label>
                        <md-input
                          v-model="createData.averageAnnualWage"
                          type="number"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </div>
                <div v-if="myData.type === 'advanced'">
                  <div class="input-section-label">
                    Liabilities
                  </div>
                  <div class="client-name-box">
                    <div class="field-wrap">
                      <md-field>
                        <label>Accounts Payable</label>
                        <md-input
                          v-model="createData.accountsPayable"
                          type="number"
                        ></md-input>
                      </md-field>
                      <md-field>
                        <label>Loans/Notes Payable</label>
                        <md-input
                          v-model="createData.loansNotesPayable"
                          type="number"
                        ></md-input>
                      </md-field>
                      <md-field>
                        <label>Other Current Liabilities</label>
                        <md-input
                          v-model="createData.otherCurrentLiabilities"
                          type="number"
                        ></md-input>
                      </md-field>
                      <md-field>
                        <label>Total Long Term Liabilities</label>
                        <md-input
                          v-model="createData.totalLongTermLiabilities"
                          type="number"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </div>
                <div v-if="myData.type === 'advanced'">
                  <div class="input-section-label">
                    Other
                  </div>
                  <div class="client-name-box">
                    <div class="field-wrap">
                      <md-field>
                        <label>FTE Employees</label>
                        <md-input
                          v-model="createData.employment"
                          type="number"
                        ></md-input>
                      </md-field>
                      <md-field>
                        <label>Avg. Annual Wage</label>
                        <md-input
                          v-model="createData.averageAnnualWage"
                          type="number"
                        ></md-input>
                      </md-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
                  slot="content-right"
                >
                  <div class="text-left">
                    <div v-if="newInputStep === 1">
                      <md-button
                        class="md-info md-round mb-4 md-theme-default"
                        type="button"
                        @click="saveMyData()"
                      >
                        <i class="md-icon md-icon-font md-theme-default"
                          >check</i
                        >
                        Select
                      </md-button>
                    </div>
                    <div v-if="newInputStep === 3">
                      <br />
                      <md-button
                        class="md-info md-round mb-4 md-theme-default"
                        type="button"
                        @click="addNewYear()"
                        v-if="yearCount < 6"
                      >
                        <i class="md-icon md-icon-font md-theme-default">add</i>
                        Add another year
                      </md-button>
                      <md-button
                        class="md-info md-round mb-4 md-theme-default"
                        type="button"
                        @click="saveNewInput()"
                      >
                        <i class="md-icon md-icon-font md-theme-default"
                          >save</i
                        >
                        Finish
                      </md-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import {
  // SignupCard,
  StatsCard,
  TableCard,
  Modal,
  ValidationError,
  ProgressBar
} from '@/components';
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {PulseLoader} from '@/components';
import moment from 'moment';
import formMixin from '@/mixins/form-mixin';
import { mapState } from 'vuex';

export default {
  name: 'new-report',
  components: {
    // SignupCard,
    StatsCard,
    TableCard,
    PulseLoader,
    Modal,
    ValidationError,
    ProgressBar
  },
  mixins: [formMixin],
  data() {
    return {
      loaded: false,
      newInputsModal: false,
      newInputType: 'simple',
      newInputStep: 1,
      inputDescription: '',
      inputDataSource: '',
      selected: [],
      tableData: [],
      myData: { type: 'simple' },
      createData: {},
      yearCount: 1,
      parsedYears: [],
      progress: 0
    };
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
  },
  methods: {
    getAllMyData: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      this.loaded = false;

      let params = {
        session_id: currentSession,
      };

      await this.$store.dispatch('myData/list', params).then((res) => {
        let myData = res.data.my_data;
        this.parseTableData(myData);
        this.loaded = true;
      });
    },
    parseTableData: async function(myData) {
      this.tableData = [];

      myData.forEach((data) => {
        this.tableData.push({
          id: data.id,
          dateCreated: moment(data.dateCreated).format('YYYY-MM-DD'),
          client: data.user.firstName + ' ' + data.user.lastName,
          inputsType: data.type,
          search: '<md-icon>manage_search</md-icon>',
          dataSource: data.dataSource,
          description: data.description,
        });
      });
    },
    showNewInputsModal: async function(type) {
      this.newInputsModal = true;
      this.newInputType = type;
      this.progress = 10;
    },
    closeNewInputsModal: async function() {
      this.newInputsModal = false;
      this.newInputStep = 1;
      this.progress = 0;
    },
    addNewYear: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.myData.id;
      let type = this.myData.type;
      let createData = this.createData;
      createData.myDataId = myDataId;

      let params = {
        type: type,
        session_id: currentSession,
        data: createData,
      };

      await this.$store.dispatch('year/add', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Year created.');
        this.createData = {};
        this.yearCount = this.yearCount + 1;

        var element = this.$el.querySelector('#modal-content');
        element.scrollTop = 0;
      });
    },
    saveMyData: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let params = {
        session_id: currentSession,
        type: this.newInputType,
        description: this.inputDescription,
        data_source: this.inputDataSource,
      };

      await this.$store.dispatch('myData/add', params).then((res) => {
        this.myData = res.data.my_data;
        this.newInputStep = 2;
        this.$store.dispatch('alerts/success', 'My data saved.');
        this.progress = 20;
      });
    },
    saveNewInput: async function() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      let myDataId = this.myData.id;
      let type = this.myData.type;
      let createData = this.createData;
      createData.myDataId = myDataId;

      let params = {
        type: type,
        session_id: currentSession,
        data: createData,
      };

      await this.$store.dispatch('year/add', params).then((res) => {
        this.$store.dispatch('alerts/success', 'Inputs created.');
        this.$router.push({
          name: 'CreateNewReport',
          query: { 'data-id': this.myData.id },
        });
        this.progress = 40;
      });
    },
    chooseInputFormat: async function(type) {
      if (type === 'csv') {
        this.$refs.csvInput.click();
        this.progress = 30;
      }
      if (type === 'inputs') {
        this.newInputStep = 3;
        this.progress = 30;
      }
    },
    fileSelected: async function(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      let file = files[0];

      this.uploadCSVFile(file);
    },
    uploadCSVFile: async function(file) {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      var form = new FormData();
      form.append('csv', file);
      form.append('type', this.myData.type);
      form.append('my_data_id', this.myData.id);
      form.append('session_id', currentSession);

      await this.$store.dispatch('myData/csv', form).then(async (res) => {
        this.$store.dispatch('alerts/success', 'Inputs created.');

        if (res.data.csv_data) {
          // await this.parseCSVResponse(res.data.csv_data);
          this.$router.push({
            name: 'CreateNewReport',
            query: { 'data-id': this.myData.id },
          });
        } else {
          this.$store.dispatch('alerts/error', 'Invalid CSV data format!');
        }
      });
    },
    parseCSVResponse: async function(data) {
      let parsed = [];
      data.forEach((row) => {
        if (row[0] === 'DO NOT ALTER ANY INPUT CODES OR THE INPUT LOCATIONS') {
          return;
        }
        if (
          row[0] ===
          'INPUTS MUST BE IN PLAIN NUMBERS; NO DOLLAR SIGNS OR OTHER CURRENCY INDICATORS'
        ) {
          return;
        }
        if (
          !row[0] &&
          !row[1] &&
          Number.isInteger(row[2]) &&
          Number.isInteger(row[3]) &&
          Number.isInteger(row[4]) &&
          Number.isInteger(row[5]) &&
          Number.isInteger(row[6])
        ) {
          this.parsedYears = row.filter((n) => n);
          this.createData.year = row[2];
        }

        if (row[0] === 'pl1') {
          this.createData.businessRevenue = row[2];
          return;
        }
        if (row[0] === 'pl2') {
          this.createData.costOfSalesLaborPortion = row[2];
          return;
        }
        if (row[0] === 'pl3') {
          this.createData.grossMargin = row[2];
          return;
        }
        if (row[0] === 'pl4') {
          this.createData.officersComp = row[2];
          return;
        }
        if (row[0] === 'pl5') {
          this.createData.salaryWages = row[2];
          return;
        }
        if (row[0] === 'pl6') {
          this.createData.rent = row[2];
          return;
        }
        if (row[0] === 'pl7') {
          this.createData.taxesPaid = row[2];
          return;
        }
        if (row[0] === 'pl8') {
          this.createData.advertising = row[2];
          return;
        }
        if (row[0] === 'pl9') {
          this.createData.benefitsPension = row[2];
          return;
        }
        if (row[0] === 'pl10') {
          this.createData.repairs = row[2];
          return;
        }
        if (row[0] === 'pl11') {
          this.createData.badDebt = row[2];
          return;
        }
        if (row[0] === 'pl12') {
          this.createData.salesGeneralAdminMisc = row[2];
          return;
        }
        if (row[0] === 'pl13') {
          this.createData.amortizationDepreciationDepletion = row[2];
          return;
        }
        if (row[0] === 'pl14') {
          this.createData.interestIncome = row[2];
          return;
        }
        if (row[0] === 'pl15') {
          this.createData.interestExpense = row[2];
          return;
        }
        if (row[0] === 'pl16') {
          this.createData.otherIncome = row[2];
          return;
        }
        if (row[0] === 'pl17') {
          this.createData.incomeTax = row[2];
          return;
        }
        if (row[0] === 'pl18') {
          this.createData.businessRevenue = row[2];
          return;
        }

        if (row[0] === 'bs1') {
          this.createData.cash = row[2];
          return;
        }
        if (row[0] === 'bs2') {
          this.createData.receivables = row[2];
          return;
        }
        if (row[0] === 'bs3') {
          this.createData.inventory = row[2];
          return;
        }
        if (row[0] === 'bs4') {
          this.createData.otherCurrentAssets = row[2];
          return;
        }
        if (row[0] === 'bs5') {
          this.createData.grossFixedAssets = row[2];
          return;
        }
        if (row[0] === 'bs6') {
          this.createData.accumDepreciationAmortizationDepltn = row[2];
          return;
        }
        if (row[0] === 'bs7') {
          this.createData.netFixedAssets = row[2];
          return;
        }
        if (row[0] === 'bs8') {
          this.createData.otherNonCurrentAssets = row[2];
          return;
        }
        if (row[0] === 'bs9') {
          this.createData.accountsPayable = row[2];
          return;
        }
        if (row[0] === 'bs10') {
          this.createData.loansNotesPayable = row[2];
          return;
        }
        if (row[0] === 'bs11') {
          this.createData.otherCurrentLiabilities = row[2];
          return;
        }
        if (row[0] === 'bs12') {
          this.createData.totalLongTermLiabilities = row[2];
          return;
        }
        if (row[0] === 'bs13') {
          this.createData.employment = row[2];
          return;
        }
        if (row[0] === 'bs14') {
          this.createData.averageAnnualWage = row[2];
          return;
        }
      });
    },
    openReportType: async function(id) {
      this.$router.push({
        name: 'CreateNewReport',
        query: { 'data-id': id },
      });
    },
  },
  async created() {
    await this.getAllMyData();
  },
};
</script>
<style lang="scss">
.new-report-body {
  .new-report {
    display: flex;
  }
}
</style>
